import './styles/globals.css';
import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import ProfilePage from './pages/ProfilePage';
import TeacherHomePage from './pages/TeacherHomePage';
import AdminHomePage from './pages/AdminHomePage';
import AdminUsersIndexPage from './pages/AdminUsersIndexPage';
import AdminUsersAddPage from './pages/AdminUsersAddPage';
import AdminUsersEditPage from './pages/AdminUsersEditPage';
import AdminLaporanKTSPage from './pages/AdminLaporanKTSPage';
import LaporKTSPage from './pages/LaporKTSPage';
import StatusSiswaPage from './pages/StatusSiswaPage';
import RequestPage from './pages/RequestPage';
import ReportPage from './pages/ReportPage';
import PelayananPage from './pages/PelayananPage';
import PanduanDoaPage from './pages/PanduanDoaPage';
import ObatPage from './pages/ObatPage';
import RekapPage from './pages/RekapPage';
import SuratIjinRekapPage from './pages/SuratIjinRekapPage';
import LaporanGuruRekapPage from './pages/LaporanGuruRekapPage';
import PenitensiRekapPage from './pages/PenitensiRekapPage';
import RekapLaporanPage from './pages/RekapLaporanPage';
import KonselingPage from './pages/KonselingPage';
import SettingsPage from './pages/SettingsPage';
import ActivityDetailPage from './pages/ActivityDetailPage';
import ForgetPasswordPage from './pages/ForgetPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import Navbar from './components/Navbar';
import styled from 'styled-components';
import { ThemeProvider } from './contexts/ThemeContext';
import ManajemenSiswaPage from './pages/ManajemenSiswaPage';
import ManajemenGuruPage from './pages/ManajemenGuruPage';
import AdminKonselingPage from './pages/AdminKonselingPage';
import AdminSuratIjinPage from './pages/AdminSuratIjinPage';
import AdminSuratIjinTidakMasukPage from './pages/AdminSuratIjinTidakMasukPage';
import AdminDaftarPelanggaranPage from './pages/AdminDaftarPelanggaranPage';
import AdminSuratIjinPulangAwalPage from './pages/AdminSuratIjinPulangAwalPage';
import AdminLaporanLemburPage from './pages/AdminLaporanLemburPage';
import AdminLaporanKersosPage from './pages/AdminLaporanKersosPage';
import AdminLaporanPSMPage from './pages/AdminLaporanPSMPage';
import AdminDaftarApresiasiPage from './pages/AdminDaftarApresiasiPage';
import AdminStokObatPage from './pages/AdminStokObatPage';
import AdminDaftarDoaPage from './pages/AdminDaftarDoaPage';
import AdminPengumumanPage from './pages/AdminPengumumanPage';
import AdminSuratPeringatanPage from './pages/AdminSuratPeringatanPage';
import WaliKelasMonitoringPage from './pages/WaliKelasMonitoringPage';
import WaliKelasReportsDetailPage from './pages/WaliKelasReportsDetailPage';
import TeacherLaporanLemburPage from './pages/TeacherLaporanLemburPage';
import TeacherLaporLemburPage from './pages/TeacherLaporLemburPage';
import TeacherIjinInterupsiPage from './pages/TeacherIjinInterupsiPage';
import PrivateRoute from './components/PrivateRoute';
import AdminLayout from './layouts/AdminLayout';
import AdminLaporKTSPage from './pages/AdminLaporKTSPage';
import AdminLoginLogPage from './pages/AdminLoginLogPage';
import AdminIjinInterupsiPage from './pages/AdminIjinInterupsiPage';
import AdminUtilitasUbahStatusPage from './pages/AdminUtilitasUbahStatusPage';

function App() {
  // Initialize state from localStorage
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    return localStorage.getItem('isAuthenticated') === 'true';
  });
  const [userRole, setUserRole] = useState(() => {
    return localStorage.getItem('userRole') || 'student';
  });
  const [adminSidebarOpen, setAdminSidebarOpen] = useState(false);
  
  const toggleAdminSidebar = () => {
    setAdminSidebarOpen(!adminSidebarOpen);
  };

  // Update localStorage when authentication state changes
  useEffect(() => {
    localStorage.setItem('isAuthenticated', isAuthenticated);
    localStorage.setItem('userRole', userRole);
  }, [isAuthenticated, userRole]);

  const handleLogin = async (credentials) => {
    try {
      const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';
      const response = await fetch(`${API_BASE_URL.replace(/\/$/, '')}/api/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify({
          email: credentials.username,
          password: credentials.password,
        }),
      });
      if (!response.ok) {
        throw new Error('Nama pengguna atau kata sandi tidak valid');
      }
      const data = await response.json();

      // Save token and role to localStorage
      localStorage.setItem('token', data.token);
      localStorage.setItem('userRole', data.role);
      localStorage.setItem('user', JSON.stringify(data.user));
      localStorage.setItem('isAuthenticated', 'true');
      setIsAuthenticated(true);
      setUserRole(data.role);
      return true;
    } catch (error) {
      // Optionally log error
      setIsAuthenticated(false);
      setUserRole('');
      localStorage.removeItem('token');
      localStorage.removeItem('userRole'); 
      localStorage.removeItem('user');
      localStorage.setItem('isAuthenticated', 'false');
      return false;
    }
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    setUserRole('student');
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('userRole');
    localStorage.removeItem('user');
    localStorage.removeItem('token');
  };

  // Helper function to determine home route based on user role
  const getHomeRoute = (role) => {
    switch(role) {
      case 'teacher':
        return '/teacher';
      case 'admin_user':
        return '/admin';
      case 'student':
          return '/home';
      default:
        return '/home';
    }
  };

  return (
    <ThemeProvider>
      <AppContainer>
        <ContentWrapper>
          {isAuthenticated && <Navbar onLogout={handleLogout} userRole={userRole} onAdminSidebarToggle={toggleAdminSidebar} />}
          <MainContent>
            <Routes>
              <Route 
                path="/" 
                element={
                  isAuthenticated ? 
                  <Navigate to={getHomeRoute(userRole)} /> : 
                  <LoginPage onLogin={handleLogin} />
                } 
              />
              <Route 
                path="/login" 
                element={
                  isAuthenticated ? 
                  <Navigate to={getHomeRoute(userRole)} /> : 
                  <LoginPage onLogin={handleLogin} />
                } 
              />
              <Route 
                path="/forget-password" 
                element={
                  isAuthenticated ? 
                  <Navigate to={getHomeRoute(userRole)} /> : 
                  <ForgetPasswordPage />
                } 
              />
              <Route 
                path="/reset-password" 
                element={
                  isAuthenticated ? 
                  <Navigate to={getHomeRoute(userRole)} /> : 
                  <ResetPasswordPage />
                } 
              />
              <Route 
                path="/home" 
                element={
                  isAuthenticated ? 
                  (userRole === 'student' ? <ProfilePage /> : <Navigate to={getHomeRoute(userRole)} />) : 
                  <Navigate to="/" />
                } 
              />
              <Route 
                path="/teacher" 
                element={
                  isAuthenticated && userRole === 'teacher' ? 
                  <TeacherHomePage /> : 
                  <Navigate to="/" />
                } 
              />
              <Route 
                path="/teacher/lapor-kts" 
                element={
                  isAuthenticated && userRole === 'teacher' ? 
                  <LaporKTSPage /> : 
                  <Navigate to="/" />
                } 
              />
              <Route 
                path="/teacher/lapor-lembur" 
                element={
                  isAuthenticated && userRole === 'teacher' ? 
                  <TeacherLaporLemburPage /> : 
                  <Navigate to="/" />
                } 
              />
              <Route 
                path="/teacher/status-siswa" 
                element={
                  isAuthenticated && userRole === 'teacher' ? 
                  <StatusSiswaPage /> : 
                  <Navigate to="/" />
                } 
              />
              <Route 
                path="/teacher/rekap-laporan" 
                element={
                  isAuthenticated && userRole === 'teacher' ? 
                  <RekapLaporanPage /> : 
                  <Navigate to="/" />
                } 
              />
              <Route 
                path="/teacher/konseling" 
                element={
                  isAuthenticated && userRole === 'teacher' ? 
                  <KonselingPage /> : 
                  <Navigate to="/" />
                } 
              />
              <Route 
                path="/teacher/laporan-lembur" 
                element={
                  isAuthenticated && userRole === 'teacher' ? 
                  <TeacherLaporanLemburPage /> : 
                  <Navigate to="/" />
                } 
              />
              <Route 
                path="/teacher/ijin-interupsi" 
                element={
                  isAuthenticated && userRole === 'teacher' ? 
                  <TeacherIjinInterupsiPage /> : 
                  <Navigate to="/" />
                } 
              />
              <Route 
                path="/teacher/wali-kelas-monitoring" 
                element={
                  isAuthenticated && userRole === 'teacher' ? 
                  <WaliKelasMonitoringPage /> : 
                  <Navigate to="/" />
                } 
              />
              <Route 
                path="/teacher/wali-kelas-reports/:reportType" 
                element={
                  isAuthenticated && userRole === 'teacher' ? 
                  <WaliKelasReportsDetailPage /> : 
                  <Navigate to="/" />
                } 
              />
              <Route 
                path="/admin/wali-kelas-reports/:reportType" 
                element={
                  isAuthenticated && userRole === 'admin_user' ? 
                  <WaliKelasReportsDetailPage /> : 
                  <Navigate to="/" />
                } 
              />
              <Route 
                path="/admin" 
                element={
                  isAuthenticated && userRole === 'admin_user' ? 
                  <AdminHomePage isSidebarOpen={adminSidebarOpen} onSidebarToggle={toggleAdminSidebar} /> : 
                  <Navigate to="/" />
                } 
              />
              <Route
                path="/admin/users"
                element={
                  isAuthenticated && userRole === 'admin_user' ?
                  <AdminUsersIndexPage /> :
                  <Navigate to="/" />
                }
              />
              <Route
                path="/admin/login-log"
                element={
                  isAuthenticated && userRole === 'admin_user' ?
                  <AdminLoginLogPage /> :
                  <Navigate to="/" />
                }
              />
              <Route
                path="/admin/add"
                element={
                  isAuthenticated && userRole === 'admin_user' ?
                  <AdminUsersAddPage /> :
                  <Navigate to="/" />
                }
              />
              <Route
                path="/admin/edit/:id"
                element={
                  isAuthenticated && userRole === 'admin_user' ?
                  <AdminUsersEditPage /> :
                  <Navigate to="/" />
                }
              />
              <Route
                path="/admin/surat-ijin-tidakmasuk"
                element={
                  isAuthenticated && userRole === 'admin_user' ?
                  <AdminSuratIjinTidakMasukPage /> :
                  <Navigate to="/" />
                }
              />
              <Route
                path="/admin/daftar-pelanggaran"
                element={
                  isAuthenticated && userRole === 'admin_user' ?
                  <AdminDaftarPelanggaranPage /> :
                  <Navigate to="/" />
                }
              />
              <Route
                path="/admin/daftar-apresiasi"
                element={
                  isAuthenticated && userRole === 'admin_user' ?
                  <AdminDaftarApresiasiPage /> :
                  <Navigate to="/" />
                }
              />
              <Route
                path="/admin/stok-obat"
                element={
                  isAuthenticated && userRole === 'admin_user' ?
                  <AdminStokObatPage /> :
                  <Navigate to="/" />
                }
              />
              <Route
                path="/admin/daftar-doa"
                element={
                  isAuthenticated && userRole === 'admin_user' ?
                  <AdminDaftarDoaPage /> :
                  <Navigate to="/" />
                }
              />
              <Route
                path="/admin/surat-peringatan"
                element={
                  isAuthenticated && userRole === 'admin_user' ?
                  <AdminSuratPeringatanPage /> :
                  <Navigate to="/" />
                }
              />
              <Route
                path="/admin/pengumuman"
                element={
                  isAuthenticated && userRole === 'admin_user' ?
                  <AdminPengumumanPage /> :
                  <Navigate to="/" />
                }
              />
              <Route
                path="/admin/surat-ijin-pulang-awal"
                element={
                  isAuthenticated && userRole === 'admin_user'
                    ? <AdminSuratIjinPulangAwalPage />
                    : <Navigate to="/" />
                }
              />
              <Route
                path="/admin/laporan-lembur"
                element={
                  isAuthenticated && userRole === 'admin_user'
                    ? <AdminLaporanLemburPage />
                    : <Navigate to="/" />
                }
              />
              <Route
                path="/admin/laporan-kersos"
                element={
                  isAuthenticated && userRole === 'admin_user'
                    ? <AdminLaporanKersosPage />
                    : <Navigate to="/" />
                }
              />
              <Route
                path="/admin/laporan-psm"
                element={
                  isAuthenticated && userRole === 'admin_user'
                    ? <AdminLaporanPSMPage isSidebarOpen={adminSidebarOpen} onSidebarToggle={toggleAdminSidebar} />
                    : <Navigate to="/" />
                }
              />
              <Route 
                path="/admin/laporan-kts" 
                element={
                  isAuthenticated && userRole === 'admin_user' ? 
                  <AdminLaporanKTSPage /> : 
                  <Navigate to="/" />
                } 
              />
              <Route 
                path="/admin/lapor-kts" 
                element={
                  isAuthenticated && userRole === 'admin_user' ? 
                  <AdminLaporKTSPage isSidebarOpen={adminSidebarOpen} onSidebarToggle={toggleAdminSidebar} /> : 
                  <Navigate to="/" />
                } 
              />
              <Route 
                path="/admin/manajemen-siswa" 
                element={
                  isAuthenticated && userRole === 'admin_user' ? 
                  <ManajemenSiswaPage /> : 
                  <Navigate to="/" />
                } 
              />
              <Route 
                path="/admin/status-siswa" 
                element={
                  isAuthenticated && userRole === 'admin_user' ? 
                  <StatusSiswaPage /> : 
                  <Navigate to="/" />
                } 
              />
              <Route 
                path="/admin/manajemen-guru" 
                element={
                  isAuthenticated && userRole === 'admin_user' ? 
                  <ManajemenGuruPage /> : 
                  <Navigate to="/" />
                } 
              />
              <Route 
                path="/admin/konseling" 
                element={
                  isAuthenticated && userRole === 'admin_user' ? 
                  <AdminKonselingPage /> : 
                  <Navigate to="/" />
                } 
              />
              <Route 
                path="/admin/surat-ijin" 
                element={
                  isAuthenticated && userRole === 'admin_user' ? 
                  <AdminSuratIjinPage /> : 
                  <Navigate to="/" />
                } 
              />
              <Route 
                path="/admin/ijin-interupsi" 
                element={
                  isAuthenticated && userRole === 'admin_user' ? 
                  <AdminIjinInterupsiPage isSidebarOpen={adminSidebarOpen} onSidebarToggle={toggleAdminSidebar} /> : 
                  <Navigate to="/" />
                } 
              />
              <Route 
                path="/admin/utilitas/ubah-status-ditolak" 
                element={
                  isAuthenticated && userRole === 'admin_user' ? 
                  <AdminUtilitasUbahStatusPage /> : 
                  <Navigate to="/" />
                } 
              />
              <Route 
                path="/admin/wali-kelas-monitoring" 
                element={
                  isAuthenticated && userRole === 'admin_user' ? 
                  <WaliKelasMonitoringPage /> : 
                  <Navigate to="/" />
                } 
              />
              {/* <Route 
                path="/admin/surat-ijin-tidak-masuk" 
                element={
                  <PrivateRoute 
                    isAuthenticated={isAuthenticated} 
                    allowedRoles={['admin']} 
                    userRole={userRole}
                  >
                    <AdminLayout>
                      <AdminSuratIjinTidakMasukPage />
                    </AdminLayout>
                  </PrivateRoute>
                } 
              /> */}
              <Route 
                path="/profile" 
                element={
                  isAuthenticated ? 
                  <Navigate to="/home" /> : 
                  <Navigate to="/" />
                } 
              />
              <Route 
                path="/profil" 
                element={
                  isAuthenticated && userRole === 'student' ? 
                  <ProfilePage profileMode={true} /> : 
                  <Navigate to="/" />
                } 
              />
              <Route 
                path="/surat-ijin" 
                element={
                  isAuthenticated && userRole === 'student' ? 
                  <RequestPage /> : 
                  <Navigate to="/" />
                } 
              />
              <Route 
                path="/laporan" 
                element={
                  isAuthenticated && userRole === 'student' ? 
                  <ReportPage /> : 
                  <Navigate to="/" />
                } 
              />
              <Route 
                path="/pelayanan" 
                element={
                  isAuthenticated && userRole === 'student' ? 
                  <PelayananPage /> : 
                  <Navigate to="/" />
                } 
              />
              <Route 
                path="/panduan-doa" 
                element={
                  isAuthenticated && userRole === 'student' ? 
                  <PanduanDoaPage /> : 
                  <Navigate to="/" />
                } 
              />
              <Route 
                path="/obat" 
                element={
                  isAuthenticated && userRole === 'student' ? 
                  <ObatPage /> : 
                  <Navigate to="/" />
                } 
              />
              <Route 
                path="/rekap" 
                element={
                  isAuthenticated && (userRole === 'teacher' || userRole === 'student') ? 
                  <RekapPage /> : 
                  <Navigate to="/" />
                } 
              />
              <Route 
                path="/rekap/surat-ijin" 
                element={
                  isAuthenticated && userRole === 'teacher' ? 
                  <SuratIjinRekapPage /> : 
                  <Navigate to="/" />
                } 
              />
              <Route 
                path="/rekap/laporan-guru" 
                element={
                  isAuthenticated && userRole === 'teacher' ? 
                  <LaporanGuruRekapPage /> : 
                  <Navigate to="/" />
                } 
              />
              <Route 
                path="/rekap/penitensi" 
                element={
                  isAuthenticated && userRole === 'teacher' ? 
                  <PenitensiRekapPage /> : 
                  <Navigate to="/" />
                } 
              />
              <Route 
                path="/settings" 
                element={
                  isAuthenticated ? 
                  <SettingsPage /> : 
                  <Navigate to="/" />
                } 
              />
              <Route 
                path="/activity/:id" 
                element={
                  isAuthenticated ? 
                  <ActivityDetailPage /> : 
                  <Navigate to="/" />
                } 
              />
            </Routes>
          </MainContent>
          {isAuthenticated && <Footer>
            <FooterContent>
              <FooterText>
                &copy; Copyright 2025 New SIMMICO. SMK Katolik Mikael Surakarta
              </FooterText>
            </FooterContent>
          </Footer>}
        </ContentWrapper>
      </AppContainer>
    </ThemeProvider>
  );
}

const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const MainContent = styled.main`
  flex: 1;
`;

const Footer = styled.footer`
  background-color: var(--background-light);
  border-top: 1px solid var(--border);
  padding: 1.5rem 0;
  margin-top: 2rem;
  transition: background-color 0.3s, border-color 0.3s;
`;

const FooterContent = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const FooterText = styled.p`
  color: var(--text-light);
  font-size: 0.875rem;
  text-align: center;
  font-weight: 500;
  transition: color 0.3s;
`;

export default App;
